module.exports = __webpack_public_path__ + "assets/images/logo-slogan.fa583ba5.png";